import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../../config/api';
import './AdminTables.css';

const AdminLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(getApiUrl('/api/admin/logs?limit=200'), { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => {
        if (json.success) setLogs(json.logs || []);
        else setError(json.message);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading && logs.length === 0) {
    return (
      <div className="admin-page-loading">
        <div className="admin-spinner" />
        <p>Loading logs...</p>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <h2 className="admin-page-title">Error & System Logs</h2>
      <p className="admin-page-subtitle">API errors, payment failures, booking conflicts and system activity. Timestamp and user role info.</p>
      {error && <div className="admin-page-error">{error}</div>}
      {logs.length === 0 && !error && (
        <p className="admin-empty">No system logs recorded yet. Logs are written when the app records errors or key events.</p>
      )}
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Level</th>
              <th>Category</th>
              <th>Message</th>
              <th>User role</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l._id} className={`admin-log-level-${l.level}`}>
                <td>{l.createdAt ? new Date(l.createdAt).toLocaleString() : '—'}</td>
                <td><span className="admin-badge">{l.level}</span></td>
                <td>{l.category || '—'}</td>
                <td className="admin-cell-truncate">{(l.message || '').slice(0, 100)}{(l.message || '').length > 100 ? '…' : ''}</td>
                <td>{l.userRole || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminLogs;
